import {Component} from "@angular/core";
import {Http, RequestOptions} from "@angular/http";
import {environment} from "../environments/environment";
import {Router} from "@angular/router";

@Component({
  templateUrl: "./login.component.html",
})
export class LoginComponent {
  username: string = "";
  password: string = "";

  constructor(private http: Http, private router: Router) {}

  login() {
    this.http.post(
      `${environment.httpBase}/auth/login`,
      {username: this.username, password: this.password},
      new RequestOptions({withCredentials: true}),
    )
      .toPromise()
      .then(
        (result) => {
          const json = result.json();
          this.router.navigate(["/"]);
        },
        (error) => {
          console.error(error);
          alert("Username/password is incorrect.");
        },
      );
  }
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/login.component.ts